/* eslint-disable class-methods-use-this */
import frameVertexSource from './glsl/frame.vertex';
import colorFragmentSource from './glsl/color.frag';

const zeros = n => new Float32Array(n);

/* Transparent black colour */
const clear = zeros(4);

export default class PolyFrame {

	static _inst = 0;

	_gl = null;
	_shader = null;
	_edge = null;

	constructor(gl, gor, quality) {
		this._inst = PolyFrame._inst++;
		this._gl = gl;
		try {
			this._shader = gor.createShaderProgram(`frame${this._inst}`, frameVertexSource, colorFragmentSource);
			this._edge = gor.createVertexBuffer(`frame${this._inst}`, 'interp', 1, false);
			/* Generate edge */
			const vertex_count = quality + 1;
			const edge_ar = new Float32Array(vertex_count);
			edge_ar[0] = 100; /* MAGIC for centre */
			for (let i = 1; i <= quality; i++) {
				edge_ar[i] = 2 * (i - 1) / (quality - 1) - 1;
			}
			this._edge.update(edge_ar);
		} catch (e) {
			console.error(e);
			throw new Error(`Failed to initialise ${this.constructor.name}`);
		}
	}

	defaultOpts(NSHIMMER = 8) {
		return {
			aspect_correction: zeros(2),
			sides: 3,
			size: 0,
			thickness: 0.1,
			star: 0,
			star_style: 0,
			rotation: 0,
			base_color: zeros(4),
			shimmer_color: zeros(4),
			star_color: zeros(4),
			shimmer: {
				frequency: zeros(NSHIMMER),
				magnitude: zeros(NSHIMMER),
				phase: zeros(NSHIMMER),
				scale: 0,
				shift: 0,
				skew: 0
			}
		};
	}

	draw(opts) {
		const gl = this._gl;
		const shader = this._shader;
		const edge = this._edge;
		shader.select();
		shader.setUniform('aspect_correction', opts.aspect_correction);
		shader.setUniform('sides', opts.sides);
		shader.setUniform('size', opts.size);
		shader.setUniform('star', opts.star);
		shader.setUniform('star_style', opts.star_style);
		shader.setUniform('rotation', opts.rotation);
		shader.setUniform('base_color', opts.base_color);
		shader.setUniform('shimmer_color', opts.shimmer_color);
		shader.setUniform('star_color', opts.star_color);
		shader.setUniform('shimmer_scale', opts.shimmer.scale);
		shader.setUniform('shimmer_shift', opts.shimmer.shift);
		shader.setUniform('shimmer_skew', opts.shimmer.skew);
		shader.setUniform('shimmer_frequency[0]', opts.shimmer.frequency);
		shader.setUniform('shimmer_magnitude[0]', opts.shimmer.magnitude);
		shader.setUniform('shimmer_phase[0]', opts.shimmer.phase);
		/* Outer */
		for (let side = 0; side < opts.sides; side++) {
			shader.setUniform('side', side);
			edge.draw(shader, gl.TRIANGLE_FAN);
		}
		/* Inner */
		shader.setUniform('size', opts.size * (1 - opts.thickness));
		shader.setUniform('base_color', clear);
		shader.setUniform('shimmer_color', clear);
		shader.setUniform('star_color', clear);
		for (let side = 0; side < opts.sides; side++) {
			shader.setUniform('side', side);
			edge.draw(shader, gl.TRIANGLE_FAN);
		}
	}

}
